<template>
  <div class="modal-mask" v-on:scroll="scrollMove($el)">
    <div class="modal-wrapper">
      <div class="modal-container d-flex flex-column">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>

        <div ref="learnHeader">
          <ViewHeader :basicData="basicData"></ViewHeader>
        </div>

        <div class="flex-grow-1">
          <ViewSubTab
            :setTabFixed="setTabFixed"
            @setSubTab="setSubTab"
          ></ViewSubTab>

          <div
            class=""
            v-if="basicData && learStartStatus"
            :class="setTabFixed ? 'mgt-50 mgb-60' : ''"
          >
            <component
              :is="tabType"
              :teacher="basicData.teacher"
              @setNextLesson="setNextLesson"
              @setExamineeId="setExamineeId"
              @setMissionId="setMissionId"
              @setSurveyId="setSurveyId"
              ref="contentsComp"
            ></component>
          </div>
        </div>
        <ViewFooter
          :basicData="basicData"
          :setTabFixed="setTabFixed"
          :tabType="tabType"
          :nextLessonData="nextLessonData"
          :examineeId="examineeId"
          :missionId="missionId"
          :surveyId="surveyId"
        ></ViewFooter>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 상세 메인 컴포넌트(my learning view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import learnApi from "@/api/learnApi.js";
import ViewHeader from "./view/Header.vue";
import ViewFooter from "./view/Footer.vue";
import ViewSubTab from "./view/SubTab.vue";
import ViewLesson from "./view/Lesson.vue";
import ViewExam from "./view/Exam.vue";
import ViewMission from "./view/Mission.vue";
import ViewQuestion from "./view/Question.vue";
import ViewSurvey from "./view/Survey.vue";
import { mapState, mapActions } from "vuex";

import { captureApiError } from "@/utils/sentryApiHandler";

export default {
  data() {
    return {
      tabType: "ViewLesson",
      basicData: null,
      setTabFixed: false,
      nextLessonData: null,

      learStartStatus: false,
      examineeId: 0,
      missionId: 0,
      surveyId: 0,
    };
  },

  components: {
    ViewHeader,
    ViewFooter,
    ViewSubTab,
    ViewLesson,
    ViewExam,
    ViewMission,
    ViewQuestion,
    ViewSurvey,
  },

  mixins: [topAppBarMixin],

  beforeMount() {
    this.fetchData();
  },

  methods: {
    ...mapActions("learn", ["SET_PROGRESS"]),

    // 텝 설정(set tab)
    setSubTab(type) {
      this.tabType = type;
    },

    // 기본정보 API 호출 및 데이터 설정(get data)
    fetchData() {
      let responseData = null;
      let params = this.setParams();
      this.$showLoading();

      // get learn basic information
      learnApi
        .learnViewBasic(params)
        .then((response) => {
          this.basicData = response.data.data;
          this.SET_PROGRESS({
            id: this.basicData.id,
            progress: this.basicData.progression,
          });

          // set learning status
          learnApi.learnStart(params).then((response) => {
            this.learStartStatus = true;
          }).catch((err) => {
            captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
          });

          this.$hideLoading();
        })
        .catch((err) => {
          responseData = err.response.data.meta;
          this.$error({ content: responseData.errMsg }).then(() => {});
          captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        });
    },

    //파라미터 설정(set parameter)
    setParams() {
      const params = {
        learnId: this.$route.params.learnId,
      };
      return params;
    },

    // 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
    scrollMove(el) {
      if (
        parseInt(el.scrollTop) >= parseInt(this.$refs.learnHeader.offsetHeight)
      ) {
        this.setTabFixed = true;
      } else {
        this.setTabFixed = false;
      }
    },

    // set next lesson
    setNextLesson(data) {
      this.nextLessonData = data;
    },

    // set examinee
    setExamineeId(data) {
      this.examineeId = data;
    },

    // set mission
    setMissionId(data) {
      this.missionId = data;
    },

    // set survey
    setSurveyId(data) {
      this.surveyId = data;
    },
  },
};
</script>